import type { FaireProductEntity } from "../../entity_types/product";

export const p_32kc4ma84p: FaireProductEntity = {
  token: "p_32kc4ma84p",
  type: "product",
  name: 'First Aid "Loaded" MiniKit (60 pcs)',
  brandToken: "b_yhc5n72agd",
  brandName: "KEEP>GOING First Aid",
  imageUrl:
    "https://cdn.faire.com/fastly/028130a3703f7eb4d00283805c67ec3f8c6b502e1ea14619d166dc761e56ed69.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f90b2fe049111a60f5460b1309efd9c5a5f33c85cae2246a8a366ad81e24c516.jpeg",
    "https://cdn.faire.com/fastly/06d47b035fe5a30fd424ba7c1aee44084b9c8f6f654bc0d4a64495364f8226de.png",
    "https://cdn.faire.com/fastly/14528aeaaff6e7e118c0b658f9f1dc244605fea52b95f482d52655c976ee8c33.jpeg",
    "https://cdn.faire.com/fastly/91cdae0ec3a1f12e1dcc13219df3517339e6a90ef68c0904ac5397c00be734eb.png",
    "https://cdn.faire.com/fastly/f1c1a3f9a0e3bdb0b31b1d75930aa5861462491c9929afd4354fbb3a8f1ed515.png",
    "https://cdn.faire.com/fastly/e3bc09b605b25bd436251af5bbe8943a9159154b297119551637eebe0a8b1991.png",
    "https://cdn.faire.com/fastly/2388090794c7c42450aeba27f152eed5f32dd2b23b2377c838d16341dbcec247.png",
    "https://cdn.faire.com/fastly/45b9e6ad5c54b534bae93fc82c913aa47f14bbf787237afa2290100b67cae22e.png",
    "https://cdn.faire.com/fastly/d2f5c1378678473d4f98a0433026bb41c0051e9ed8a2b97363a494d39e78032d.jpeg",
    "https://cdn.faire.com/fastly/c85f0536a98cd395675450b399abbbdc2b9b3a7032253417b59079e38948a87a.jpeg",
  ],
  priceDollars: 12.99,
  description:
    '\nFirst Aid Kit for on the go \n\n * Small case but fully loaded with 60 Premium First Aid items \n * Includes Metal Tweezers, Wipes, Ointments, Assorted Bandages, and much more (see below for full list) \n * Carabiner attaches easily to backpack, stroller, or small purse \n * All Contents are 100% Latex-Free \n * HSA/FSA eligible \n * Size: 4.5" x 3.75" x 1.75" \n * Due to the small size, we could not add extra pockets (that make our GoKit and SuperKit so organized) ',
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:39.974Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
